import { render, staticRenderFns } from "./EventHistoryContactPersonChangedProps.vue?vue&type=template&id=9b5a9d56&scoped=true"
import script from "./EventHistoryContactPersonChangedProps.vue?vue&type=script&lang=js"
export * from "./EventHistoryContactPersonChangedProps.vue?vue&type=script&lang=js"
import style0 from "./EventHistoryContactPersonChangedProps.vue?vue&type=style&index=0&id=9b5a9d56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5a9d56",
  null
  
)

export default component.exports